<template>

	<NbExpanding>
		<nav v-show="visible" class="lobby-theme-menu-list">
			<div class="">
				<ul class="nav">
					<li v-for="menu in menus" :class="{active:menu.active}">
						<a href="javascript:void(0)" @click="menuClick(menu)">
							<span class="nav-label">{{menu.name}}</span>
							<i v-if="menu.isParent()" @click.stop.prevent="menu.active = !menu.active;" class="pull-right fa"
							   :class="{'fa-angle-left':!menu.active,'fa-angle-down':menu.active}"></i>
						</a>
						<NbExpanding>
							<ul
								v-show="menu.active"
								v-if="menu.menus && menu.menus.length"
								class="nav nav-second-level"
							>
								<li v-for="(menu1, index1) in menu.menus" :class="{active:menu1.active}">
									<a href="javascript:void(0)" @click="menuClick(menu1)">
										{{menu1.name}}
									</a>

								</li>
							</ul>
						</NbExpanding>

					</li>

				</ul>
			</div>
		</nav>
	</NbExpanding>


</template>
<script>

	import NbExpanding from "../../../../common/widget/NbExpanding.vue";
	import TopicMenu from "../../../../common/model/topic/TopicMenu";


	export default {
		//这个值代表的是开或者关的状态。
		model: {
			prop: 'visible',
			event: 'toggle'
		},
		props: {
			visible: {
				type: Boolean,
				required: false,
				"default": false
			},
			menus: {
				type: Array,
				required: true
			},
			callback: {
				type: Function,
				required: false
			}
		},
		computed: {},
		components: {
			NbExpanding
		},
		methods: {
			menuClick(menu){

				menu.click();
				this.$emit('toggle', false);
				this.callback && this.callback(menu);
			}
		},
		watch: {},
		mounted(){

		}
	}
</script>


<style lang="less" rel="stylesheet/less">

	.lobby-theme-menu-list {

		//Navigation
		@nav-bg: #2F4050;
		@nav-text-color: #a7b1c2;
		@navy: #1ab394;

		background: darken(@nav-bg, 3%);

		//放头像和用户名的地方。
		.menu-header {

			border-bottom: 1px solid #2F4458;
			padding-bottom: 20px;
			.logo-area {
				cursor: pointer;
				text-align: center;
				padding: 20px 0;
			}

			.text-area {
				.nickname {
					text-align: center;
					color: @nav-text-color;
					font-weight: bold;

				}
				.role {
					text-align: center;
					color: @nav-text-color;
				}
			}

		}

		.nav {
			li {

				&.active {
					border-left: 4px solid darken(@navy, 2%);

					//只有紧接的这一层a才会高亮。
					> a {
						color: #ffffff;
					}
				}

				a {
					background-color: darken(@nav-bg, 3%);
					color: @nav-text-color;
					font-weight: 600;
					padding: 12px 20px;
					&:hover, &:focus {
						color: white;
					}

					i {
						margin-right: 6px;
					}
				}
			}
			&.nav-first-level {
				&.active {
				}
			}
			&.nav-second-level {
				padding-left: 15px;
				li {
					&.active {
						border: none;
					}
				}
			}
			&.nav-third-level {
				padding-left: 30px;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// MenuListView.vue?03bfb8db